import { render, staticRenderFns } from "./epson_sales_items_temp1.vue?vue&type=template&id=49635cc4&"
import script from "./epson_sales_items_temp1.vue?vue&type=script&lang=js&"
export * from "./epson_sales_items_temp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports